import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import type { QtyControlProps } from '../types';

const QtyControl: React.FC<QtyControlProps> = ({ quantity, onIncrement, onDecrement, size = 'md' }) => {
    const iconSize = size === 'sm' ? 17 : 24;
    const btnClass = size === 'sm' ? 'posv2-qty-btn posv2-qty-btn--sm' : 'posv2-qty-btn';

    return (
        <div
            className={`posv2-qty-control posv2-qty-control--${size}`}
            onClick={(e) => e.stopPropagation()}
        >
            <button className={btnClass} onClick={onDecrement} aria-label="Decrease quantity">
                <RemoveIcon sx={{ fontSize: iconSize }} />
            </button>
            <span className={size === 'sm' ? 'posv2-cart-item__qty' : 'posv2-qty-value'}>
                {quantity}
            </span>
            <button className={btnClass} onClick={onIncrement} aria-label="Increase quantity">
                <AddIcon sx={{ fontSize: iconSize }} />
            </button>
        </div>
    );
};

export default React.memo(QtyControl);
